import SwitchIcon from './component'

export default SwitchIcon
